import $ from "jquery";
import "slick-carousel";
import AOS from "aos";
import lozad from "lozad";

$(function () {
	"use strict";

	// Slick sliders
	$(".ProductListingCarousel-slick").on("init", function (event, slick) {
		AOS.init();
		const observer = lozad(); // lazy loads elements with default selector as ".lozad"
		observer.observe();
	});
	$(".ProductListingCarousel-slick").slick({
		centerMode: true,
		arrows: true,
		dots: false,
		infinite: true,
		variableWidth: true,
		slidesToShow: 2,
		rows: 0,
		responsive: [
			{
				breakpoint: 924,
				settings: {
					dots: false,
					arrows: true,
					rows: 0,
					infinite: true,
					slidesToShow: 1
				}
			}
		]
	});

});


import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
